/** Visit outcomes and marks, off for everyone since 29 Oct 2026 (owner: skipped for now).
 *  Mirrors the server's api.MarksAndOutcomes; flip both to bring them back. */
export const MARKS_AND_OUTCOMES: boolean = false

/** Audit actions of outcomes and marks, left out of the filter while they are off. */
export const MARKS_AND_OUTCOMES_ACTIONS: ReadonlySet<string> = new Set([
  'catalogue.outcome_create',
  'catalogue.outcome_update',
  'catalogue.mark_create',
  'catalogue.mark_update',
])
